// extracted by mini-css-extract-plugin
module.exports = {"nounWrapper":"Auction_nounWrapper__3JSNc","nounContentCol":"Auction_nounContentCol__1o5ER","auctionActivityCol":"Auction_auctionActivityCol__3U2jw"};